import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class JobService {
  private apiUrl = environment.apiUrl;


  constructor(private http: HttpClient) {}

  searchJobs(params: any): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        httpParams = httpParams.set(key, params[key]);
      }
    });
    return this.http.get(`${this.apiUrl}/api/job-lists/search`, { params: httpParams });
  }

  createJob(jobData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/job-lists/create`, jobData);
  }

  updateJob(jobData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/job-lists/${jobData.job_code}`, jobData);
  }
  
  assignJobToEmployee(employee_id: string, job_code: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/job-lists/assign`, { employee_id, job_code });
  }
}
